
import { usePage } from '@inertiajs/vue3';

// import { getCurrentInstance, defineAsyncComponent, ref } from "vue";
// import { /* getCurrentInstance, ref,  */defineAsyncComponent } from "@vue/runtime-core";


// import store_state_app from '@stores/app/state' //*OK  Vuex
import { appStore } from '@stores' //* Pinia

export {
    // ci,         //* currentInstance
    // proto,      //* config.globalProperties  //! NON, n'est pas accessible dans les stores/actions !!!
    // app_state,  //* VueX Store State app // in setup : app_state.value.  // in template : app_state.
    app_state,  //* Pinia Store State app // use: app_state().
    pp,         //* $page.props
    pp_user,
    // $ac,        //* defineAsyncComponent
    // $ac2,
}

// console.log('in helpers/app.js', usePage(), appStore())

// const ci = ()=>  getCurrentInstance()


// const proto = ()=>{
//     return ci()?.appContext?.config?.globalProperties || {}
// }

// const app_state = ref(store_state_app)/*?.value NON */ // VueX
// const app_state = ()=>appStore()
// const app_state = ()=>storeToRefs(appStore)
const app_state = ()=> appStore().$state


const pp = ()=> usePage()?.props//?.value


const pp_user = ()=> pp()?.user || {}


// const $ac = defineAsyncComponent
// const $ac2 = (v)=>defineAsyncComponent((v)=>import(v))